import { useEffect } from "react";

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

/**
 * Sets document title, meta description, OG tags, canonical and an optional
 * BreadcrumbList JSON-LD. City-aware for future local pages.
 */
export const Seo = ({ title, description, path = "/", breadcrumb, suffix = true }) => {
  useEffect(() => {
    const base = "https://umbo-it.fr";
    const fullTitle = title ? (suffix ? `${title} — Umbo` : title) : "Umbo";
    document.title = fullTitle;
    upsertMeta("name", "description", description || "");
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description || "");
    upsertMeta("property", "og:url", base + path);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", base + path);

    if (breadcrumb && breadcrumb.length) {
      upsertJsonLd("breadcrumb-jsonld", {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumb.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: base + b.path,
        })),
      });
    }
    return () => {
      const el = document.getElementById("breadcrumb-jsonld");
      if (el) el.remove();
    };
  }, [title, description, path, breadcrumb, suffix]);

  return null;
};
